import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import getters from './getters'

import {
  StorageStack
} from '@/common/Stack'
Vue.use(Vuex)

const state = {
  count: 0,
  breadcrumb: [],
  StorageStack: new StorageStack(),
  loginInfo: null
}


export default new Vuex.Store({
  state,
  mutations,
  getters
})



// WEBPACK FOOTER //
// ./src/store/index.js